export default {
  title: "vision каталог".toUpperCase(),
  rating: "рейтинг".toUpperCase(),
  rating_changes: "изменение рейтинга".toUpperCase(),
  medals: "награды".toUpperCase(),
  description: "описание".toUpperCase(),

  ///////////
  brief: "бриф".toUpperCase(),
  brief_category: "номинация".toUpperCase(),
  brief_meaning: "описание".toUpperCase(),
  brief_score: "рейтинг".toUpperCase(),

  brief_category_audience: "аудитория".toUpperCase(),
  brief_category_activeness: "активность".toUpperCase(),
  brief_category_botting: "боты".toUpperCase(),
  brief_category_networking: "связи".toUpperCase(),
  brief_category_effective_of_promotions: "эффективность рекламы".toUpperCase(),
  brief_category_moderation: "модерация".toUpperCase(),
  brief_category_organicity: "органичность трафика".toUpperCase(),
  brief_category_admins: "администрация".toUpperCase(),
  brief_category_knowledge_sharing: "knowledge sharing".toUpperCase(),
  brief_category_additions: "additions".toUpperCase(),
  /////////
  rules: "правила".toUpperCase(),
  admins: "админы".toUpperCase(),

  admin: {
    view_account: "перейти в профиль".toUpperCase(),
  },
}
